import { render, staticRenderFns } from "./DemoSliderAppendTextField.vue?vue&type=template&id=8f37bf22&"
import script from "./DemoSliderAppendTextField.vue?vue&type=script&lang=js&"
export * from "./DemoSliderAppendTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VResponsive,VSlider,VTextField})
